import Button from "components/Button";
import React from "react";
import JsxParser from "react-jsx-parser";
import constants from "utils/constants";
import styles from "./styles.module.scss";

interface Props {
  label: string;
  texts: string[];
}

const QuotationResultText: React.FC<Props> = ({ label, texts }) => {
  return (
    <div className={styles.resultText}>
      <div className={styles.label}>{label}</div>
      {texts.map((text, index) => (
        <JsxParser
          className={styles.text}
          components={{
            highlight: (data: { children?: React.ReactNode }) => {
              return (
                <span className={styles.highlighted}>{data.children}</span>
              );
            },
            facebook: (data: { children?: React.ReactNode }) => {
              return (
                <Button
                  className={styles.button}
                  href={constants.facebook}
                  iconClassName={styles.icon}
                  showNewWindowIcon
                  target="_blank"
                  type="link"
                >
                  {data.children}
                </Button>
              );
            },
          }}
          jsx={text}
          key={index}
        />
      ))}
    </div>
  );
};

export default QuotationResultText;
